import transition from './transition';

export default transition;
